import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@lore/auth';
import { useQueryMutation } from '@lore/query-connect';
import ParentLayout from './Layout';
import Loader from '@/components/Loader';

export default function Create() {
  const navigate = useNavigate();
  const user = useUser();

  const mutation = useQueryMutation('project.create');
  const { success, isError, request } = mutation;

  // prevents duplicate POSTs (including React 18 StrictMode dev behavior)
  const hasCreatedRef = useRef(false);
  const firstSite = user.data?.sites?.find((site) => site.siteId);

  useEffect(() => {
    if (success) {
      navigate(`/post-project/${request.id}`, { replace: true });
    }
  }, [success, navigate, request?.id]);

  useEffect(() => {
    if (isError) {
      navigate('/', { replace: true });
    }
  }, [isError, navigate]);

  useEffect(() => {
    if (!user?.id) return;
    if (hasCreatedRef.current) return;

    hasCreatedRef.current = true;
    mutation.mutate({
      creatorId: user.id,
      siteId: firstSite?.siteId
    });
  }, [user?.id, firstSite]);

  return (
    <ParentLayout
      page="Create project"
      title={<Loader />}
    >
      <div className="px-16 lg:px-32 pt-32">
        <Loader />
      </div>
    </ParentLayout>
  );
}
